import { defineStore } from "pinia";
import { ticketsApi } from "@/api/tickets";

export const useTicketMetaStore = defineStore("ticketMeta", {
  state: () => ({
    loading: false,
    loaded: false,
    error: null,
    // departments: [],
    statuses: [],
    // priorities: [],
    categories: [],
    permissions: {},
  }),

  actions: {
    async fetchMetadataOnce() {
      if (this.loaded || this.loading) return;

      this.loading = true;
      this.error = null;

      try {
        const data = await ticketsApi.metadata();
        // this.departments = data?.departments || [];
        this.statuses = data?.statuses || [];
        // this.priorities = data?.priorities || [];
        this.categories = data?.categories || [];
        this.permissions = data?.permissions || {};
        this.loaded = true;
      } catch (e) {
        this.error = e;
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    reset() {
      this.loading = false;
      this.loaded = false;
      this.error = null;
      // this.departments = [];
      this.statuses = [];
      // this.priorities = [];
      this.categories = [];
      this.permissions = {};
    },
  },
});
